import type React from 'react'
import type {
	ControllerConfig,
	HasValueSignature,
	InitialValueSignature,
	OptionType,
	UseSelectOptionsSignature,
	ValueState,
} from '../../types'

import { Operators } from '@/shared/components/query-builder'

import { isObject } from '../../utils'
import FieldController from '../Controller'

export default class SelectController extends FieldController {
	constructor(config: ControllerConfig) {
		super(config)
		this.onMenuScrollToBottom = config.onMenuScrollToBottom
		this.onMenuScrollToTop = config.onMenuScrollToTop
		this.useSelectOptions = config.useSelectOptions
		this.getInitialValue = config.getInitialValue || this.getInitialValue
		this.placeholder = config.placeholder || this.placeholder
		this.formatOptionLabel = config.formatOptionLabel
	}

	formatOptionLabel?: (option: OptionType) => React.ReactNode
	onMenuScrollToBottom?: () => void

	onMenuScrollToTop?: () => void

	placeholder?: string

	useSelectOptions: () => UseSelectOptionsSignature<OptionType>

	hasValue: HasValueSignature = ({ value }) =>
		Array.isArray(value) ? value.length > 0 : isObject(value)

	getInitialValue: InitialValueSignature = () => ({
		operation: Operators.IN,
		value: [],
	})

	formatLabel = ({ value }: ValueState<string[]>) => {
		if (Array.isArray(value) && value.length > 0)
			return `${this.label} (${value.length})`

		return this.label
	}
}
